/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TimeseriesYAxisAnnotation } from './TimeseriesYAxisAnnotation';
import {
    TimeseriesYAxisAnnotationFromJSON,
    TimeseriesYAxisAnnotationFromJSONTyped,
    TimeseriesYAxisAnnotationToJSON,
} from './TimeseriesYAxisAnnotation';

/**
 * 
 * @export
 * @interface TimeseriesAnnotations
 */
export interface TimeseriesAnnotations {
    /**
     * contains yAxis markings for the chart
     * @type {Array<TimeseriesYAxisAnnotation>}
     * @memberof TimeseriesAnnotations
     */
    yAxis?: Array<TimeseriesYAxisAnnotation>;
}

/**
 * Check if a given object implements the TimeseriesAnnotations interface.
 */
export function instanceOfTimeseriesAnnotations(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TimeseriesAnnotationsFromJSON(json: any): TimeseriesAnnotations {
    return TimeseriesAnnotationsFromJSONTyped(json, false);
}

export function TimeseriesAnnotationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeseriesAnnotations {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'yAxis': !exists(json, 'yAxis') ? undefined : ((json['yAxis'] as Array<any>).map(TimeseriesYAxisAnnotationFromJSON)),
    };
}

export function TimeseriesAnnotationsToJSON(value?: TimeseriesAnnotations | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'yAxis': value.yAxis === undefined ? undefined : ((value.yAxis as Array<any>).map(TimeseriesYAxisAnnotationToJSON)),
    };
}

